module.exports = __webpack_public_path__ + "static/media/3-square-dirty.41f0ea3c.svg";